import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogos_Otros, cargarCatalogosGenericoAsyncInvertido, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { completar_String, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

const ContainerConbinado = styled.div`
    margin-top: 8px;
`;

const LabelSub = styled.label`
    font-weight: 200;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const InputTextUnion = styled.input`
    height: 25px;
    padding: 5px 10px;
    font-size: 11px;
    z-index: 0;
`;

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

const Button = styled.button`
    .medida-button-busq-Select{
        padding: 4px 6px;
    }
    height: 27px;
    font-size: 11px;
    @media(min-width: 800px){
        margin-top: 18px;
        width: ${props => props.ancho? props.ancho: 100}%;
    }
`;

const LabelTotal = styled.label`
    font-size: 10px;
    color: ${props => props.color?props.color:'green'};
    margin-right: ${props => props.margenderecha?props.derecha:'15'}px;
    float: ${props => props.alineacion?props.alineacion:'right'};
    margin-top: ${props => props.margen_arriba?props.margen_arriba:'3px'}'px';
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:'0px'}'px';
`;

class FormBanco03 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global
            movimientoId: '',
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            planVigente: null,
            SecuenciaCheque: null,//SEC DE CHEQUE SELECCIONADO +1
            diario: null,
            ult_transaccion: null,
            num_diario: null,

            //AUXILIARES
            cod_proveedor: null, //COD DEL PROVEEDOR
            ctaParametroImp: null, //parametroCTAImp
            controlGasto: 0,


            //CUENTAS BANCARIAS - FLAG AL PREGUNTAR PARA GRABAR SI NO TIENEN CUENTA NO PERMITE GRABAR
            cuentaDeporpas: null,  //SU VALOR === null cuando la cuenta no tiene registrada una cuenta contable
            cuentaProveedor: null, //CUENTA CONTABLE PROVEEDOR
            bancoSel: null, //NOMBRE CUENTA BANCARIA

            //SELECTS
            caja_sel: null,
            catCuentas: [], //catalogos a mostrar en combo cta bancaria
            catCuentas_sel: null, //cuenta bancaria seleccionada
            catGastoImportacion: [], //ADICION DE CAT DE GASTOS DE IMPORTACION
            catGastoImportacion_sel: null, // GASTO SELECCIONADO
            catRubroGastoImportacion: [],   //mbaquero
            catRubroGastoImportacion_sel: null,
            deshabilitaGasto: true,

            //SELECTS ASYNC
            importacion_sel: null,
            cuentas_sel: null,            

            //Radio
            opciones: 'O', //OPCION POR DEFECTO PROVEEDOR
            tipo: 'NDE',

            //Inputs
            nombreProveedor: '',
            referencia: '',
            concepto: '',
            refBancaria: '',
            switf: '',
            valorAdd: '',
            ident_prov:'',
            total_nota: '', //Total del documento a ingresar (IMPORTACION ONLY)

            //Label
            valAplicado: 0,
            totalGrid: 0,
            totalDebe: 0,
            totalHaber: 0,

            //ENVIO DE PARAMETRO PROVEEDOR
            beneficiarioSend: '',

            //GRID
            data_abonos_import: [],
            columnDefs_abonos: [    {   header: "Sec",
                                        field: "Secuencia",
                                        width: 35,
                                        type: "string"
                                    },  
                                    {   header: "Abono",
                                        field: "Abono",
                                        width: 50,
                                        type: "num_entero"                                             
                                    },                                
                                    {   header: "Fecha Pago",
                                        field: "FechaPago",
                                        width: 100,
                                        type: "fecha"                       
                                    },                                    
                                    {   header: "Valor",
                                        field: "Valor",
                                        width: 65,
                                        type: "num_decimal"                                              
                                    },                                    
                                ],
            columnDefs_modal:  [    {   header: "Sec",
                                        field: "Secuencia",
                                        width: 35,
                                        type: "string"
                                    },
                                    {   header: "Tipo",
                                        field: "Descripcion",
                                        width: 120,
                                        type: "string"
                                    },                                   
                                    {   header: "Fecha Pago",
                                        field: "Fecha",
                                        width: 75,
                                        type: "fecha"                       
                                    },
                                    {   header: "D.P.",
                                        field: "DiasPlazo",
                                        width: 35,
                                        type: "num_entero"                                             
                                    },
                                    {   header: "%",
                                        field: "Porcentaje",
                                        width: 30,
                                        type: "num_entero"                                             
                                    },                                
                                    {   header: "Total",
                                        field: "ValorCalculado",
                                        width: 65,
                                        type: "num_decimal"                                             
                                    },                                    
                                    {   header: "Saldo",
                                        field: "Saldo",
                                        width: 65,
                                        type: "num_decimal"                                             
                                    },
                                    {   header: "Val Pagar",
                                        field: "Aplicado",
                                        width: 65,
                                        type: "num_decimal_edit",
                                        editable: true                                                 
                                    },
                                    {   header: "Abono",
                                        field: "Abono",
                                        width: 65,
                                        type: "num_decimal"                                             
                                    },                                       
                                ],
            data_modal_forma_pg: [],
            data_gridCuentas: [],
            columDefGridCuentas:[   
                                    {  header: "Sec",
                                        field: "secuencia",
                                        width: 40,
                                        type: "string"
                                    },
                                    {   header: "Cuenta",
                                        field: "cuenta",
                                        width: 120,
                                        type: "string"
                                    },                                   
                                    {   header: "Descripción",
                                        field: "descripcion",
                                        width: 140,
                                        type: "string"                       
                                    },
                                    {   header: "Concepto",
                                        field: "concepto",
                                        width: 380,
                                        type: "string",
                                        editable: true                                             
                                    },
                                    {   header: "D/H",
                                        field: "DebeHaber",
                                        width: 40,
                                        type: "string",
                                        editable: true                                            
                                    },                                                               
                                    {   header: "Debe",
                                        field: "Debe",
                                        width: 70,
                                        type: "num_decimal"                                             
                                    },
                                    {   header: "Haber",
                                        field: "Haber",
                                        width: 70,
                                        type: "num_decimal"                                             
                                    },
                                    {   header: "Nombre Gasto",  /* mbaquero */
                                        field: "nombre_gasto",
                                        width: 110,
                                        type: "string"                                             
                                    },
                                    {   header: "CodigoGasto",  /* mbaquero */
                                        field: "codigoGasto",
                                        hide: true,
                                        type: "string"                                             
                                    },
                                    {   header: "",
                                        field: "eliminar",
                                        width: 50,
                                        type: "link_elim"                                                
                                    },                             
                                ],
            gridDocsPendientes: [],
            coldefDocsPendientes:[    
                                    {   header: "N°",
                                        field: "Secuencia",
                                        width: 30,
                                        type: "num_entero"
                                    },
                                    {   header: "Fecha Fac.",
                                        field: "Fecha_FAC",
                                        width: 80,
                                        type: "fecha"
                                    },
                                    {   header: "Fecha Ven.",
                                        field: "Fecha_VEN",
                                        width: 80,
                                        type: "fecha"
                                    }, 
                                    {   header: "Proveedor",
                                        field: "Proveedor",
                                        width: 160,
                                        type: "string"
                                    },               
                                    {   header: "Tipo",
                                        field: "Tipo",
                                        width: 40,
                                        type: "string"
                                    },
                                    {   header: "#. Doc.",
                                        field: "Num_Doc",
                                        width: 95,
                                        type: "string"
                                    },
                                    {   header: "Saldo",
                                        field: "Saldo",
                                        width: 70,
                                        type: "num_decimal"
                                    },
                                    {   header: "Val Pagar",
                                        field: "Valor_Pagar",
                                        width: 70,
                                        type: "num_decimal_edit",
                                        valueFormatter: this.formatearNumero, 
                                        editable: true                                          
                                    }
                                ],
            gridSeleccionComprasProv: [],
            colDefSeleccionComprasProv:[  
                                            {   header: "",
                                                width: 30,                    
                                                checkboxSelection: true,
                                                suppressSorting: true,
                                                suppressMenu: true,
                                                suppressFilter: true,
                                                pinned: true                                                
                                            },        
                                            {   header: "N°",
                                                field: "Secuencia",
                                                width: 30,
                                                type: "num_entero"
                                            },
                                            {   header: "Fecha Fac.",
                                                field: "Fecha_FAC",
                                                width: 80,
                                                type: "fecha"
                                            },
                                            {   header: "Fecha Ven.",
                                                field: "Fecha_VEN",
                                                width: 80,
                                                type: "fecha"
                                            },            
                                            {   header: "Tipo",
                                                field: "Tipo",
                                                width: 40,
                                                type: "string"
                                            },
                                            {   header: "#. Doc.",
                                                field: "Num_Doc",
                                                width: 95,
                                                type: "string"
                                            },
                                            {   header: "Saldo",
                                                field: "Saldo",
                                                width: 70,
                                                type: "num_decimal"
                                            },
                                        ],
            //TIMEPICKER
            //fechaDoc: moment(),
            fechaProceso: null,

            //Modals
            isOpenFP: false,
           
            //catalogos            
            repCuentas: [], //Trae toda la informacion necesaria de las cuentas BANCARIAS
            repCtasCaja:[], //Trae cuentas asocuadas a las cajas
        };

        //GRID OPTIONS
        //Se las formas de pago de una importacion
        this.gridImpFormaPagoOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{
                
                switch (event.colDef.field){
                    case "Aplicado":
                        console.log("CAMPO: " ,event.data)
                        if(isNaN(event.data.Aplicado)===true || event.data.Aplicado===""){
                            //RESET VALUE => no es número
                            event.data.Aplicado = 0;//event.data.Saldo
                        }else{
                            var valor_editado = 0;
                            var saldo = 0;

                            valor_editado = parseFloat(event.data.Aplicado);
                            saldo = parseFloat(event.data.Saldo);
                            if( (Math.round(valor_editado * 100)  / 100) > (Math.round(saldo * 100)  / 100)){
                                //RESET VALUE => EL VALOR SUPERA AL SALDO
                                event.data.Aplicado = Math.round(saldo * 100)  / 100;
                            }else{
                                //VALOR CORRECTO
                                event.data.Aplicado = valor_editado;
                            }
                        }

                        break
                    default:
                        break
                }
                
                this.apiImpFormaPago.refreshCells();
                //VALOR HEREDADO A VALOR ADD & ACTUALIZACION DEL VALOR APLICADO
                let aplicado = this.totalizarGrid(this.state.data_modal_forma_pg, 'Aplicado')
                this.setState({valAplicado: Math.round(aplicado * 100)  / 100}, ()=>{
                    
                    //ACTUALIZACION DE VALOR ASIENTO PROVEEDOR
                    this.state.data_gridCuentas.forEach((DATA)=>{
                        if(DATA.hasOwnProperty('filaProveedor')===true){
                            if(DATA.hasOwnProperty('DebeHaber')===true){
                                console.log("ENTRO")
                                if(DATA.DebeHaber==='H'){
                                    console.log("APLICAR: ", aplicado)
                                    DATA.Haber = Math.round(aplicado * 100)  / 100;
                                }else{
                                    console.log("APLICAR: ", aplicado)
                                    DATA.Debe = Math.round(aplicado * 100)  / 100;
                                }
                            }
                        }
                    })
                })
                //Actualiza los cambios en la fila de cuenta bancaria contra los demas cambios en las demas filas
                // let items = this.totalizarCuentas(this.state.data_gridCuentas);
                // this.updFilaAutomatica(this.state.data_gridCuentas, items.debe , items.haber)

                //Asignacion de los label de totales de debe y haber con valores finales
                let final = this.totalizarCuentas(this.state.data_gridCuentas);
                this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)})

                this.apiCuentas.refreshCells();
            }),
            onCellEditingStarted:((event)=> {
            })
        };

        //Se cargan Docs de compras
        this.docsPendientesOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{}),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{
                
                //formatearNumeroDecimal
                switch (event.colDef.field){
                    case "Valor_Pagar":
                        if(isNaN(event.data.Valor_Pagar)===true || event.data.Valor_Pagar===""){
                            //delete event.data.Valor_Pagar; 
                            event.data.Valor_Pagar = event.data.Saldo
                        }else{
                            var valor_editado = 0;
                            var saldo = 0;

                            valor_editado = parseFloat(event.data.Valor_Pagar);
                            saldo = parseFloat(event.data.Saldo);
                            if( (Math.round(valor_editado * 100) / 100) > (Math.round(saldo * 100) / 100)){
                                event.data.Valor_Pagar = Math.round(saldo  * 100 ) / 100;
                            }else{
                                //Valor correcto
                                event.data.Valor_Pagar = valor_editado;


                                let codProveedor = event.node.data.CodProveedor;
                                console.log('inicio de actualizacion ---- Proveedor: ', codProveedor)
                                let total = this.totalizarPorProveedor(codProveedor);
                                this.setState({valAplicado: total})
                                console.log("TOTAL Por Proveedor: ",total);

                                //ACTUALIZACION DE VALOR ASIENTO PROVEEDOR
                                this.state.data_gridCuentas.forEach((DATA)=>{
                                    if(DATA.hasOwnProperty('filaProveedor')===true && DATA.CodProveedor === codProveedor){
                                        if(DATA.hasOwnProperty('DebeHaber')===true){
                                            console.log("ENTRO")
                                            if(DATA.DebeHaber==='H'){
                                                console.log("APLICAR: ", total)
                                                DATA.Haber = Math.round(total * 100) / 100;
                                            }else{
                                                console.log("APLICAR: ", total)
                                                DATA.Debe = Math.round(total * 100) / 100;
                                            }
                                        }
                                    }
                                })

                                //Asignacion de los label de totales de debe y haber con valores finales
                                let final = this.totalizarCuentas(this.state.data_gridCuentas);
                                this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)}
                                ,()=>{
                                    this.apiCuentas.refreshCells();
                                })
                            }
                        }

                    break
                    default:
                    break
                }
                this.apiDocsPendientes.refreshCells();
            }),
            onCellEditingStarted:((event)=> {}),
            onRowDoubleClicked: ((event)=>{
                console.log(event)
                let mensaje = window.confirm('Eliminar la fila seleccionada.');
                if(mensaje){
                    this.setState({ gridDocsPendientes: this.immutableDelete(this.state.gridDocsPendientes, event.node.rowIndex)}
                    ,()=>{
                        //MODFICICAR GRID CUENTAS DESPUES DE ELIMINAR

                        let codProveedor = event.node.data.CodProveedor;
                        let total = this.totalizarPorProveedor(codProveedor);
                        this.setState({valAplicado: total})
                        this.actualizacionGridCuentasValores(total, codProveedor)

                        //Asignacion de los label de totales de debe y haber con valores finales
                        let final = this.totalizarCuentas(this.state.data_gridCuentas);
                        this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)}
                        ,()=>{
                            //AJUSTE DE INDICE DESPUES DE ELIMiNAR
                            this.state.gridDocsPendientes.forEach((DET, i)=>{
                                DET.Secuencia = completar_String(i + 1, '0', 3);
                            })
                            this.apiCuentas.refreshCells();
                        })
                    })
                }
                
            })
        };

        //Asiento de DMovBanco
        this.gridCuentasOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{
                //formatearNumeroDecimal
                console.log("FILA: ",event.colDef.field)
                switch (event.colDef.field){
                    case "DebeHaber":
                        if(event.data.secuencia!=='001'){
                            if(event.data.DebeHaber.toString().toUpperCase().trim()==='D' && event.oldValue!==event.newValue){
                                if(event.oldValue.toString().toUpperCase().trim()!==event.newValue.toString().toUpperCase().trim()){                                    
                                    event.data.Debe = event.data.Haber;
                                    event.data.DebeHaber = event.data.DebeHaber.toString().toUpperCase();
                                    delete event.data.Haber; 
                                }else{
                                    event.data.DebeHaber = event.oldValue;
                                }
                            }else if(event.data.DebeHaber.toString().toUpperCase().trim()==='H'){
                                if(event.oldValue.toString().toUpperCase().trim()!==event.newValue.toString().toUpperCase().trim()){                                                         
                                    event.data.Haber = event.data.Debe;
                                    event.data.DebeHaber = event.data.DebeHaber.toString().toUpperCase();
                                    delete event.data.Debe; 
                                }else{
                                    event.data.DebeHaber = event.oldValue;
                                }                            
                            }else if(event.data.DebeHaber.toString().toUpperCase().trim()==='' || (event.data.DebeHaber.toString().toUpperCase().trim()!=='H' && event.data.DebeHaber.toString().toUpperCase().trim()!=='D') ){
                                event.data.DebeHaber = event.oldValue;
                            }
                        }else{
                            event.data.DebeHaber = event.oldValue;
                        }
                    break
                    case "concepto":
                        console.log("GRID CONP: ", event.data.concepto)
                        event.data.concepto =  event.data.concepto.toString().toUpperCase();
                    break
                    default:
                    break

                }
                this.apiCuentas.refreshCells();

                //Asignacion de los label de totales de debe y haber con valores finales
                let final = this.totalizarCuentas(this.state.data_gridCuentas);
                this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)})
         
                
            }),
            onCellEditingStarted:((event)=> {})
        };

        //AbonosCargados
        this.gridAbonosOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{                
            }),
            onCellEditingStarted:((event)=> {})
        };

        //SeleccionCompras
        this.gridSeleccionComprasProvOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
                if(event.node.selected === true){
                    let fila = this.apiSeleccionComprasProv.getSelectedRows()[0];

                    let sec = this.state.gridDocsPendientes.length + 1;
                    fila = {...fila, Secuencia: sec }

                    let repetido = this.verificarDocumentosRepetidos(this.state.gridDocsPendientes, fila);

                    if(repetido === false){
                        this.setState({ gridDocsPendientes: this.immutablePush(this.state.gridDocsPendientes, fila)}
                        ,()=>{
                            //FUNCION PARA CREAR FILA AUTOMATICA DE PROVEEDOR SIN CONSULTAR RECIBE VALOR YA CONSULTADOS POR ESTE METODO
                            let cuenta = {};
                            cuenta.Cuenta = this.state.cuentaProveedor;
                            cuenta.Nombre = fila.Proveedor;
                            if(this.state.cuentaProveedor){
                                this.addCtaCompraProveedor(cuenta, fila.Saldo, fila);
                            }
                        })
                    }else{
                        alert(`- El documento del proveedor ${fila.Proveedor} #:${fila.Num_Doc}, ya se encuentra ingresado.`)
                    }
                }
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{}),
            onCellEditingStarted:((event)=>{})
        };

        //OverControls
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.actualizarTipo = this.actualizarTipo.bind(this);
        this.onChangeMonto = this.onChangeMonto.bind(this);
        this.AsignarValorCuentaBanco = this.AsignarValorCuentaBanco.bind(this);
        this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
        this.validarMontoAdicion = this.validarMontoAdicion.bind(this);
        this.changeIdProveedor = this.changeIdProveedor.bind(this);

        //OP
        this.changeCuentaBancaria = this.changeCuentaBancaria.bind(this);
        this.validarcuentaBancaria = this.validarcuentaBancaria.bind(this);
        this.addCuenta = this.addCuenta.bind(this);
        this.getFormaPagoImp = this.getFormaPagoImp.bind(this);
        this.getProveedor = this.getProveedor.bind(this);
        this.guardarNotaDebitoCredito = this.guardarNotaDebitoCredito.bind(this);
        this.getCreditoDebitoById = this.getCreditoDebitoById.bind(this);
        this.anularDebitoCredito = this.anularDebitoCredito.bind(this);
        this.addMovAutomaticoAsiento = this.addMovAutomaticoAsiento.bind(this);
        this.disableTotalDoc = this.disableTotalDoc.bind(this);
        this.setCodGastoImportacion = this.setCodGastoImportacion.bind(this);
        this.impRecibo = this.impRecibo.bind(this);
        this.clearDocsProcesados = this.clearDocsProcesados.bind(this);
        this.handleHabilitaGasto= this.handleHabilitaGasto.bind(this); //mbaquero

        //GRID
        this.onGridImpFormaPagoReady = this.onGridImpFormaPagoReady.bind(this);
        this.onGridCuentasReady = this.onGridCuentasReady.bind(this);
        this.onGridDocsPendientesReady = this.onGridDocsPendientesReady.bind(this);
        this.onGridAbonosImportReady = this.onGridAbonosImportReady.bind(this);
        this.onGridSeleccionComprasProvReady = this.onGridSeleccionComprasProvReady.bind(this);
    }

    // mbaquero
    handleHabilitaGasto()
    {
        if (this.state.cuentas_sel !== null) 
             if (this.state.cuentas_sel.value.toString().trim() !== this.state.ctaParametroImp){
                this.setState({deshabilitaGasto: true})}
            else{
                this.setState({deshabilitaGasto: false})
        }
    }

    //Formater
    formatearNumero(params){
        return parseFloat(params.value).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }

    //OverControls
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });

        if(target.type ==='radio'){
            this.clear();
            //this.clearIngCtasBeneficiario();
        }
    }

    actualizarTipo(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.value;
        this.setState({
          [name]: value
        });

        if(target.type ==='radio'){
            this.clear();
            //this.clearIngCtasBeneficiario();
        }

        if(target.type ==='radio' && name==='tipo' && value==='NCR'){
            this.setState({opciones: 'O'});
        }
    }

    changeIdProveedor(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=20){
            if(isNaN(value)===false){
                this.setState({[name]: value});
            }
        } 
    }

    //GRIDS
    onGridImpFormaPagoReady(params){
        this.apiImpFormaPago = params.api;
        this.columnApiImpFormaPago = params.columnApi;
    }

    onGridCuentasReady(params){
        this.apiCuentas = params.api;
        this.columnApiCuentas = params.columnApi;
    }

    onGridDocsPendientesReady(params){
        this.apiDocsPendientes = params.api;
        this.columnApiDocsPendientes = params.columnApi;
    }

    onGridAbonosImportReady(params){
        this.apiAbonoImport = params.api;
        this.columnApiAbonoImport = params.columnApi;
    }

    onGridSeleccionComprasProvReady(params){
        this.apiSeleccionComprasProv = params.api;
        this.columnApiSeleccionComprasProv = params.columnApi;
    }

    totalizarPorProveedor(proveedor){
        
        let acc = 0;
        this.state.gridDocsPendientes.forEach((DOCS)=>{
            if(proveedor === DOCS.CodProveedor){
                acc += parseFloat(DOCS.Valor_Pagar);
            }
        })

        return Math.round(acc*100)/100;
    }

    changeStateHeader(gridApi,colApi, colField, value){

        var col = colApi.getColumn(colField);
        var colDef = col.getColDef();
        colDef.editable = value;
        gridApi.refreshHeader();
    }

    toggleModalFormaPago = () => {
        this.setState({
            isOpenFP: !this.state.isOpenFP
        });
    }

    changeCuentaBancaria(value){
        this.setState({cuentaDeporpas: null}, ()=>{

            this.setState({catCuentas_sel: value!==null?value.value:null})
            if(value!==null){
                let response;
                response = this.validarcuentaBancaria(value.value);
                if(response!==false && this.state.operacion === 'G'){
                    //Adicion de Asiento contable
                    this.addMovAutomaticoAsiento(this.state.data_gridCuentas, response, value.label);
                }else if(response!==false && this.state.operacion === 'M'){
                    //ACTUALIZAR EL BANCO SELECCIONADO
                    this.updCambioBanco(this.state.data_gridCuentas, response, this.formatearBanco(value.label));

                }
            }
        })
    }

    formatearBanco(label, codigo){
        let char = codigo==='09'?" ":"-";
        let temp = label.split(char);
        console.log('SPLIT BANCO: ',temp)
        return temp[0];
    }

    //Actualiza el CUENTA Y DESCRIPCION en caso de modificacion del banco (NO AFECTA VALORES)
    updCambioBanco(array, cuenta , descripcion){
        array.forEach((DATA)=>{
            if(DATA.secuencia === '001'){
                DATA.cuenta = cuenta.toString().trim();
                DATA.descripcion = descripcion.toString().trim();
                DATA.auto = 1
            }
        })
    }

    //No esta el Siguiente esta el ultimo ingresado
    validarcuentaBancaria(value){
        var conCuenta = "";
        this.state.repCuentas.forEach((CUENTA)=>{
            if(CUENTA.Codigo === value){
                conCuenta = CUENTA.ConCuenta
                this.setState({SecuenciaCheque: CUENTA.SecuenciaCheque+1, num_chq: ''});
            }
        })

        if(conCuenta !== ""){
            this.setState({cuentaDeporpas: conCuenta})
            return conCuenta;
        }else{
            //CUENTA BANCARIA NO ASIGNADA
            alert("La cuenta bancaria seleccionada no tiene una cuenta contable asignada")
            return false
        }
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    getOptions_CtaContable(input, callback){
        /*/cuentas?cadena_busq=52.02.20.12&dep=001 FILTRO POR DEPARTAMENTO*/ 
        if (input.toString().length >= 2 ){
            /* cuentas sin filtro
            let cadena_busq = '?cadena_busq='+ input+'&plan='+this.state.planVigente.toString();
            cargarCatalogosGenericoAsyncInvertido('/cuentas', cadena_busq, callback)
            */
            let cadena_busq = '?cadena_busq='+ input+'&dep='+this.props.departamento;
            cargarCatalogosGenericoAsyncInvertido('/cuentas', cadena_busq, callback)
        }
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    validarMontoAdicion(){
        var valor = this.state.valorAdd;
        if(isNaN(parseFloat(valor))===true || valor===""){
            this.setState({valorAdd: ''});
        }else{
            //Validacion valor
            if(parseFloat(valor) <= 0){
                this.setState({valorAdd: ''});
            }else{
                this.setState({valorAdd: (valor)})
            }
        }
    }

    //UNDER VERIFICATION
    onChangeMonto(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.value;

        if(isNaN(value)===true || value===""){
            this.setState({[name]: ''});
        }else{
            //Validacion valor
            if(parseFloat(value) < 0){
                this.setState({[name]: ''});
            }else{
                this.setState({[name]: value})
            }
        }
    }

    AsignarValorCuentaBanco(){
        if(this.state.total_nota.toString() !== ''){
            var valor = this.state.total_nota;
            this.updFilaAutomatica(this.state.data_gridCuentas, valor , valor)
            
            this.apiCuentas.refreshCells();
        }
    }

    //Operaciones
    addCuenta(){
        if(this.state.cuentas_sel !== null && this.state.concepto!=='' && this.state.valorAdd!=='' && this.state.cuentaDeporpas!==null){
            var item = {};
            var label='';
            var nombre='';
            if(this.state.cuentas_sel.value === this.state.ctaParametroImp)
            {
                if(this.state.catRubroGastoImportacion_sel !== null){
                    if(parseFloat(this.state.valorAdd) > 0){
                        
    
                        item.secuencia = completar_String(this.state.data_gridCuentas.length+1, '0', 3)
                        item.cuenta = this.state.cuentas_sel.value.toString().trim();
                                                        
                        label = this.state.cuentas_sel.label.split("(");
                        nombre = label[1].toString().split(")")
                        
                        item.descripcion = nombre[0];
                        item.concepto = this.state.concepto.toString().toUpperCase();
    
                        console.log("TIPO: ", this.state.tipo)
                        if(this.state.tipo === 'NCR'){
                            console.log("HABER")
                            item.DebeHaber = 'H'
                            item.Haber = parseFloat(this.state.valorAdd);
                        }else{
                            console.log("HABER")
                            item.DebeHaber = 'D'
                            item.Debe = parseFloat(this.state.valorAdd);
                        }
                        
                        // mbaquero 20190515
                    
                        item.nombre_gasto = null; item.CodigoGastoImp = null;
                        
                        if (this.state.catRubroGastoImportacion_sel !== null)
                        {   
                            var ultchar='';
                            let arrayValidacion= this.state.catRubroGastoImportacion_sel.label.split(" (");
                            if(arrayValidacion.length>2){
                                let nombreGasto = this.state.catRubroGastoImportacion_sel.label.split(" (");
                                item.nombre_gasto=nombreGasto[0].toString().trim();
                                ultchar= nombreGasto[arrayValidacion.length-1].replace(')','');
                                item.CodigoGastoImp = ultchar.trim();
                            }else{
                                let nombreGasto = this.state.catRubroGastoImportacion_sel.label.split(" (");
                                item.nombre_gasto = nombreGasto[0].toString().trim();
                                ultchar = nombreGasto[1].replace(')','');
                                item.CodigoGastoImp = ultchar.trim();
                            }
                            
                        }
                            
                            this.setState({ data_gridCuentas: this.immutablePush(this.state.data_gridCuentas, item)},()=>{
                            this.clearIngresoCtas();
                            
                            //Actualizacion de los campos del grid
                            // let items = this.totalizarCuentas(this.state.data_gridCuentas);
                            // this.updFilaAutomatica(this.state.data_gridCuentas, items.debe , items.haber)
    
                            //Asignacion de los label de totales de debe y haber con valores finales
                            let final = this.totalizarCuentas(this.state.data_gridCuentas);
                            this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)})
                            
                            //CASO DE COPIA DE CONCEPTO PARA CUENTA BANCARIA CASO OTROS
                            if(this.state.opciones === 'O' && this.state.data_gridCuentas.length === 2){
                                this.updConceptoGridCuenta(this.state.data_gridCuentas, item.concepto);
                            }
                        }) 
                    }else{
                        alert("Ingrese valores mayores a 0")
                    }
                }else{
                    alert('Ingrese cuenta de gasto importacion')
                }
                
            }else {
                if(parseFloat(this.state.valorAdd) > 0){
                   
    
                    item.secuencia = completar_String(this.state.data_gridCuentas.length+1, '0', 3)
                    item.cuenta = this.state.cuentas_sel.value.toString().trim();
                    label = this.state.cuentas_sel.label.split("(");
                    nombre = label[1].toString().split(")")
                    
                    item.descripcion = nombre[0];
                    item.concepto = this.state.concepto.toString().toUpperCase();
    
                    console.log("TIPO: ", this.state.tipo)
                    if(this.state.tipo === 'NCR'){
                        console.log("HABER")
                        item.DebeHaber = 'H'
                        item.Haber = parseFloat(this.state.valorAdd);
                    }else{
                        console.log("HABER")
                        item.DebeHaber = 'D'
                        item.Debe = parseFloat(this.state.valorAdd);
                    }
                    
                    this.setState({ data_gridCuentas: this.immutablePush(this.state.data_gridCuentas, item)},()=>{
                        this.clearIngresoCtas();
                        //Actualizacion de los campos del grid
                        // let items = this.totalizarCuentas(this.state.data_gridCuentas);
                        // this.updFilaAutomatica(this.state.data_gridCuentas, items.debe , items.haber)
    
                        //Asignacion de los label de totales de debe y haber con valores finales
                        let final = this.totalizarCuentas(this.state.data_gridCuentas);
                        this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)})
                        
                        //CASO DE COPIA DE CONCEPTO PARA CUENTA BANCARIA CASO OTROS
                        if(this.state.opciones === 'O' && this.state.data_gridCuentas.length === 2){
                            this.updConceptoGridCuenta(this.state.data_gridCuentas, item.concepto);
                        }
                    }) 
                }else{
                    alert("Ingrese valores mayores a 0")
                }
            }
        }else{
            alert("Verifique cta. bancaria y que el item a ingresar posea cta, concepto, valor")
        }
    }

    //Aumenta el movimiento automatico segun la cuenta seleccionada
    addMovAutomaticoAsiento(array, cuenta , descripcion){
        //Siempre se asigna en movimiento del banco en 001
        //Si es primera vez elimina mov automatico
        //Si ya esta lleno
        
        var item = {};
        var opcion = '';

        if(this.state.opciones === 'I'){
            opcion = "Importación";
        }else if(this.state.opciones === 'C'){
            opcion = 'Compra';
        }else{
            opcion = 'Otros';
        }

        //var conceptoGenerico = this.state.tipo+" POR PAGO "+opcion; 
        console.log('BANCO: ', this.formatearBanco(descripcion, cuenta.toString().trim()))
        var conceptoGenerico =  `AA. ${this.state.tipo} N. ${this.state.refBancaria?this.state.refBancaria.toString().trim():''} BAN: ${descripcion.toString().trim()}, ${opcion}`

        item.secuencia = '001' //completar_String(this.state.data_gridCuentas.length+1, '0', 3)
        item.cuenta = cuenta.toString().trim();
        item.descripcion = this.formatearBanco(descripcion, cuenta.toString().trim())//descripcion.toString().trim();
        item.concepto = conceptoGenerico.toString().toUpperCase();
        
        if(this.state.tipo === 'NCR'){
            item.DebeHaber = 'D'
        }else{
            item.DebeHaber = 'H'
        }
        item.auto = 1

        console.log ('paso 1')
        item.nombre_gasto = null; item.CodigoGastoImp = null;   /* mbaquero */

        if(array.length === 0){
            this.setState({ data_gridCuentas: this.immutablePush(this.state.data_gridCuentas, item)})
        }else{
            this.setState({ data_gridCuentas: this.immutableUnshift(this.state.data_gridCuentas, item)})
        }   
    }

    //Actualiza el campo Debe o Haber de la cuenta automatica BANCOS
    updFilaAutomatica(array , debe, haber){

        //El primero siempre sera la cta automatica
       if(array[0].DebeHaber === 'D'){
            //NOTA DE CREDITO => CTAS = H
            array[0].Debe = parseFloat(haber);
       }else{
            //NOTA DE CREDITO => CTAS = D
            array[0].Haber = parseFloat(debe);
       }
       //Asignacion de los label de totales de debe y haber con valores finales
       let final = this.totalizarCuentas(this.state.data_gridCuentas);
       this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)})
    }

    //Totaliza el valor de un grid
    totalizarGrid(grid, name){
        var acc = 0;
        grid.forEach((DATA)=>{
            if(DATA.hasOwnProperty(name)===true){
                acc = acc + parseFloat(DATA[name]);
            }
        })
        return acc
    }

    //Totaliza Debe y Haber
    totalizarCuentas(grid){
        var debe = 0;
        var haber = 0;
        var items = {}
        grid.forEach((DATA)=>{
            if(DATA.hasOwnProperty('Haber')===true){
                //HABER
                if(Number.isNaN(DATA.Haber)===false){
                    haber = haber + parseFloat(DATA.Haber);
                }
            }else if(DATA.hasOwnProperty('Debe')===true){
                //DEBE
                if(Number.isNaN(DATA.Debe)===false){
                    debe = debe + parseFloat(DATA.Debe);
                }
            }
        })

        items.debe = debe;
        items.haber = haber;
        return items
    }

    //Verifica ValorAplicado VS Ctas en el asiento
    verificaValorAplicado(array , valComparacion){
        //ARRAY = GRID ASIENTO
        //DEVUELVE TRUE SI ENCONTRO UN RUBRO CON EL MISMO VALOR QUE VAL APLICADO EN FORMA DE PAGO
        var respuesta = false;
        array.forEach((DATA)=>{
            
            if(DATA.hasOwnProperty('Debe')===true){
                if(parseFloat(DATA.Debe).toFixed(2) === valComparacion){
                    respuesta = true;
                }
                
            }else if(DATA.hasOwnProperty('Haber')===true){
                if(parseFloat(DATA.Haber).toFixed(2) === valComparacion){
                    respuesta = true;
                }
            }
            
        })
        return respuesta;
    }

    //Verifica si los documentos seleccionados se encuentra en un array bajo clave proveedor , num_doc
    verificarDocumentosRepetidos(array, fila){
        let repetidos = false; 
        
        if(array.length > 0){
            array.forEach((DOC)=>{
                if(fila.Proveedor === DOC.Proveedor && fila.Num_Doc === DOC.Num_Doc){
                    repetidos = true; 
                }
            })
        }

        return repetidos;
    }

    //Opcion a consultar , Nombre del state a guardar
    cargarCatalogosOtrosCatchResult(tipo, name) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                //Atrapa resultado en un state
                console.log("COLLECCION DESDE SP: ",response.data)
                this.setState({[name]: response.data});
                
                //Muestra en el control
                resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase().trim()}-${item.Numero} (${item.Codigo.toString().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    //captura de repositorio
    cargarOtrosCatchResult(tipo, name){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                
                //Catura la respuesta y la devuelve
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            //CUENTA + PLANVIGENTE
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{
                console.log("CUENTA CONSULTADA",response)
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    //Op Arrays Inmutables
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableUnshift(array, newItem){
        return [ newItem, ...array ];
    }
    
    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    clearIngresoCtas(){
        this.setState({cuentas_sel: null, concepto: '', valorAdd: ''});
    }

    //Obtiene las formas de pago de la importacion Seleccionada
    getFormaPagoImp(){
        if(this.state.importacion_sel !==null){
            this.cargarObjetos('/pagosimportacion?importacion='+this.state.importacion_sel.value+'&opcion=saldo').then((resul)=>{
                if(resul.length>0){
                    var proveedor = {};
                    resul.forEach((DATA)=>{
                        DATA.Aplicado = 0;//DATA.Saldo.toFixed(2);
                        if(DATA.Proveedor!==null){
                            
                            proveedor.value = DATA.Proveedor.trim();
                            proveedor.label = DATA.NombreProveedor.trim();
                        }else{
                            proveedor.value = null;
                            proveedor.label = null;
                        }
                        
                    })
                    
                    this.setState({ data_modal_forma_pg: resul, nombreProveedor: proveedor.label, cod_proveedor: proveedor.value}, ()=>{

                        //VALOR HEREDADO A VALOR ADD & ACTUALIZACION DEL VALOR APLICADO
                        let aplicado = this.totalizarGrid(this.state.data_modal_forma_pg, 'Aplicado')
                        this.setState({valAplicado: Math.round(aplicado * 100)  / 100})
                        if(this.state.tipo==='NDE' && this.state.operacion==='G'){
                            //ADD CUENTA DE PROVEEDOR
                            this.addCtaContableProveedorAuto(proveedor.value, aplicado);
                        }                    
                    })//END SETSTATE
                }
            })
        }
    }

    //ADICIONA LA CUENTA AUTOMATICA DEL PROVEEDOR
    addCtaContableProveedorAuto(cod_proveedor, aplicado){
        var conCuenta = null;
        this.cargarObjetos('/proveedores/'+cod_proveedor).then((resul)=>{
            conCuenta = resul.cta_contable;

            if(conCuenta!==null){
                this.cargarCuentasContables(conCuenta.toString().trim(),this.state.planVigente).then((r_ctaContable)=>{
    
                    if(r_ctaContable===null){
                        this.setState({nombreProveedor: '', cod_proveedor: null, cuentaProveedor: null}, ()=>{
                                alert('Proveedor no tiene cuenta asociada al plan contable actual');
                            })
                    }else{
                        var verificacion = this.verificaFilaAutoProveedor(this.state.data_gridCuentas);
                        console.log("VERIFICACION FILA: ", verificacion)
                        if(verificacion === false){
                            //Creacion del registro de cuenta del proveedor
                            var item = {} 
        
                            item.secuencia = '002';
                            item.cuenta = r_ctaContable.Cuenta.toString().trim();
                            item.descripcion = this.state.nombreProveedor.toString().toUpperCase().trim(); //r_ctaContable.Nombre.toString().toUpperCase().trim();
                            item.concepto = "PAGO IMP "+parseInt(this.state.importacion_sel.value,10)+" "+item.descripcion;
                            console.log("CONCEPTO")
                            console.log(item.concepto)
                            //Campo verificador de la fila auto proveedor
                            item.filaProveedor = 1;
                            
                            if(this.state.tipo === 'NCR'){
                                item.DebeHaber = 'H'
                                item.Haber = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
                            }else{
                                item.DebeHaber = 'D'
                                item.Debe = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
                                item.autoProveedor = 1;
                            }
                            
                            item.nombre_gasto = null; item.CodigoGastoImp = null; /* mbaquero */
                            this.setState({ data_gridCuentas: this.immutablePush(this.state.data_gridCuentas, item)}, ()=>{
                                this.updConceptoGridCuenta(this.state.data_gridCuentas, item.concepto);
                            })
                        }else{
                            this.updProveedorSelected(this.state.data_gridCuentas, verificacion, r_ctaContable, aplicado)
                            this.apiCuentas.refreshCells();
                            var item2 = {} 
                            item2.descripcion = this.state.nombreProveedor.toString().toUpperCase().trim(); //r_ctaContable.Nombre.toString().toUpperCase().trim();
                            item2.concepto = "PAGO IMP "+parseInt(this.state.importacion_sel.value,10)+" "+item2.descripcion;
                            this.updConceptoGridCuenta(this.state.data_gridCuentas, item2.concepto);//willt 2020-01-09
                        }
                        
                    }
                }) 
            }else{
                alert("No tiene cuenta asignada")
            }
        }) 
    }

    //ACTUALIZA CONCEPTO DE CUENTA BANCARIA
    updConceptoGridCuenta(array, concepto){
        console.log("ESTOY EN EL ACTUALIZAR")
        array.forEach((DATA)=>{
            if(DATA.secuencia === '001'){
                DATA.concepto = concepto;
            }
        })

        this.apiCuentas.refreshCells();
    }

    //Verifica si existe FilaGenerada de Proveedor
    verificaFilaAutoProveedor(array){
        var response = false;

        array.forEach((DATA, i)=>{
            if(DATA.hasOwnProperty('autoProveedor')===true){
                response = i;
            }
        })
        return response;
    }

    //Verifica si existe una fila de Proveedor Generada y si existe retorna el index de la fila a actualizar
    verificaFilaProvGen(fila, array){
        var response = false;
        
        if(array.length > 0){
            array.forEach((DATA,i)=>{
                console.log('COD FILA: ', fila.CodProveedor ,' COD GRID: ',DATA.CodProveedor )
                if(DATA.hasOwnProperty('autoProveedor')===true && fila.CodProveedor === DATA.CodProveedor){
                    response = i;
                }
            })
        }
        
        return response;
    }

    updProveedorSelected(array, index , r_ctaContable, aplicado){
 
        array[index].cuenta = r_ctaContable.Cuenta.toString().trim();
        array[index].descripcion = r_ctaContable.Nombre.toString().toUpperCase().trim();

        if(this.state.opciones === 'I'){
            array[index].concepto = "PAGO IMP "+parseInt(this.state.importacion_sel.value,10)+" "+r_ctaContable.Nombre.toString().toUpperCase().trim();;

            if(this.state.tipo === 'NCR'){
                array[index].DebeHaber = 'H'
                array[index].Haber = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
            }else{
                array[index].DebeHaber = 'D'
                array[index].Debe = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
                array[index].autoProveedor = 1;
            }
        }else if(this.state.opciones === 'C'){
            array[index].concepto = "PG COMPRA: "+r_ctaContable.Nombre.toString().toUpperCase().trim();

            if(this.state.tipo === 'NCR'){
                array[index].DebeHaber = 'H'
                array[index].Haber = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
            }else{
                array[index].DebeHaber = 'D'
                array[index].Debe = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
                array[index].autoProveedor = 1;
            }
        }
        
    }

    //Obtiene la compra del proveedor ingresado
    getProveedor(){
        //C => OPCION COMPRA
        if(this.state.ident_prov !== null){
            var data = {}
            var cuenta = "";
            var cod_proveedor = "";
            var ident_prov = this.state.ident_prov.value;
            data.Tipo = 'F'

            this.cargarObjetos('/proveedores?tipo=indt_proveedor&ident='+ident_prov).then((result)=>{
                console.log(result)
                if(result.length > 0){
                    //Willy20191108
                    this.setState({nombreProveedor: result[0].Descripcion, cod_proveedor: result[0].Codigo,
                    cuentaProveedor: (result[0].Tipo==='S')?result[0].CuentaContableServicio:result[0].Cuenta, beneficiario: result[0].Descripcion})

                    cod_proveedor=result[0].Codigo;
                    cuenta = (result[0].Tipo==='S')?result[0].CuentaContableServicio:result[0].Cuenta;//Willy20191108

                    //Proceso de cuenta de Contable Y CARGAR GRID DE DOCUMENTOS
                    console.log("cuenta contable: ", cuenta)
                    if(cuenta!==null && this.state.opciones==='C'){
                        if(cuenta.toString().trim()!==""){
                            console.log("ENTRO")
                            this.cargarCuentasContables(cuenta.toString().trim(),this.state.planVigente).then((r_ctaContable)=>{
                                console.log("CUENTA TRAIDA: ", r_ctaContable)

                                if(r_ctaContable===null){
                                    this.setState({nombreProveedor: '', cod_proveedor: null,
                                        cuentaProveedor: null, beneficiario: ''}, ()=>{
                                            alert('Proveedor no tiene cuenta asociada al plan contable actual');
                                        })
                                }else{
                                    //TRAE GRID
                                    this.setState({cuentaProveedor: r_ctaContable.Cuenta})                              
                                    this.cargarObjetos('/compras?proveedor='+cod_proveedor+'&status=P&status=E&msaldo=0').then((result_docs)=>{
                                        
                                        console.log("DRACO: ", result_docs)
                                        var arrayDocs = [], docsProcesados = [];
                                        arrayDocs = result_docs;

                                        if(result_docs.length>0){
                                            arrayDocs.forEach((DATA, i)=>{

                                                var item = {};
                                                item.Secuencia = i+1;
                                                item.Fecha_FAC = DATA.Fecha;
                                                item.Fecha_VEN = DATA.FechaVencimiento;
                                                item.Tipo = DATA.Tipo?DATA.Tipo:'N/A';
                                                item.Num_Doc = DATA.Establecimiento.toString().trim()+''+DATA.PuntoVenta.toString().trim()+'-'+DATA.Factura.toString().trim()
                                                item.Saldo = DATA.Saldo.toFixed(2); 
                                                item.Valor_Pagar = item.Saldo;
                                                item.Compra = DATA.Compra;
                                                item.Proveedor = DATA.proDet?DATA.proDet.RazonSocial:"N/A";
                                                item.CodProveedor = DATA.Proveedor;
                                                docsProcesados.push(item);
                                            })
                                            //this.setState({gridDocsPendientes: docsProcesados})
                                            this.setState({gridSeleccionComprasProv: docsProcesados})

                                        }else{
                                            alert("El proveedor no tiene documentos pendientes")
                                        }                                       
                                    })
                                }                                
                            })
                        }else{
                            if(this.state.otras_opciones==='C'){
                                alert("El proveedor Seleccionado no posee cta de contable")
                                this.clear();
                            }
                        }
                    }else{
                        if(this.state.otras_opciones==='C'){
                            alert("El proveedor Seleccionado no posee cta de contable")
                            this.clear();
                        }
                    }

                }else{
                    this.setState({ident_prov: null}, ()=>{
                        if(result.length <= 0 && this.state.ident_prov===null){
                            alert('No existen coincidencias con el número de cédula ingresado');
                        }
                    })
                }
            })
        }
    }

    //ADICIONA CUENTA AUTOMATICA A PROVEEDOR POR COMPRAS
    addCtaCompraProveedor(cuenta, aplicado, fila){
        console.log("CUENTA: PRO ", cuenta, 'APLICADO: ', aplicado)
        console.log('FILA SEND: ', fila)
        let verificacion = this.verificaFilaProvGen(fila, this.state.data_gridCuentas);
        
        console.log("VERIFICACION FILA: ", verificacion)
        if(verificacion === false){
            //Creacion del registro de cuenta del proveedor
            var item = {} 
            let sec = this.state.data_gridCuentas.length + 1;
            item.secuencia = completar_String(sec, '0', 3);
            item.cuenta = cuenta.Cuenta.toString().trim();
            item.descripcion = cuenta.Nombre.toString().toUpperCase().trim(); //r_ctaContable.Nombre.toString().toUpperCase().trim();
            item.concepto = "PG COMPRA: "+item.descripcion;
            //Campo verificador de la fila auto proveedor
            item.filaProveedor = 1;

            //Campo añadido para identificacion
            if(this.state.opciones === 'C'){
                item.CodProveedor = fila.CodProveedor;
            }

            if(this.state.tipo === 'NCR'){
                item.DebeHaber = 'H'
                item.Haber = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
            }else{
                item.DebeHaber = 'D'
                item.Debe = parseFloat(aplicado)>0?parseFloat(aplicado).toFixed(2):0;
                item.autoProveedor = 1;
            }
            this.setState({ data_gridCuentas: this.immutablePush(this.state.data_gridCuentas, item)}
            , ()=>{
                //Total por Proveedor
                this.setState({valAplicado: aplicado})
                let final = this.totalizarCuentas(this.state.data_gridCuentas);
                this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)})
                //this.updConceptoGridCuenta(this.state.data_gridCuentas, item.concepto);
            })
        }else{
            console.log("FILA A MODIFICAR: ",verificacion)
            console.log("Cuenta a ingresar: ",cuenta)
            
            //Total por Proveedor
            let total = this.totalizarPorProveedor(fila.CodProveedor);
            this.setState({valAplicado: total})

            this.actualizacionGridCuentasValores(total , fila.CodProveedor);

            let final = this.totalizarCuentas(this.state.data_gridCuentas);
            this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)}
            ,()=>{
                this.updProveedorSelected(this.state.data_gridCuentas, verificacion, cuenta, total)
                this.apiCuentas.refreshCells();
            })
        }
    }

    actualizacionGridCuentasValores(total, condicion){
        //ACTUALIZACION DE VALOR ASIENTO PROVEEDOR
        this.state.data_gridCuentas.forEach((DATA)=>{
            if(DATA.hasOwnProperty('filaProveedor')===true && DATA.CodProveedor === condicion){
                if(DATA.hasOwnProperty('DebeHaber')===true){
                    console.log("ENTRO")
                    if(DATA.DebeHaber==='H'){
                        console.log("APLICAR: ", total)
                        DATA.Haber = Math.round(total * 100) / 100;
                    }else{
                        console.log("APLICAR: ", total)
                        DATA.Debe = Math.round(total * 100) / 100;
                    }
                }
            }
        })
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject('No existe movimiento a presentar...');
            });
        });
    }

    //Funcion que recibe parametros de la fila para eliminar
    methodFromParent(id, datos_fila){

        var mensaje;
        mensaje = window.confirm("¿Desea eliminar el registro?"); 
        
        if (mensaje){
            
            if(datos_fila.hasOwnProperty('cuenta') ){
                if(this.state.operacion==='G' && datos_fila.secuencia!=='001'){
                    this.eliminarDetalleAsiento(datos_fila ,id) 
                }else if(this.state.operacion==='M' && datos_fila.secuencia!=='001'){
                    if(this.state.operacion==='M' && this.state.opciones==='I' && datos_fila.secuencia!=='002'){
                        this.eliminarDetalleAsiento(datos_fila ,id) 
                    }else if(this.state.operacion==='M' && this.state.opciones==='C' && datos_fila.hasOwnProperty('Proveedor')===false){
                        this.eliminarDetalleAsiento(datos_fila ,id) 
                    }else if(this.state.operacion==='M' && this.state.opciones==='O' &&(datos_fila.secuencia!=='001')){
                        this.eliminarDetalleAsiento(datos_fila ,id) 
                    }else{
                        alert("las filas autogeneradas no se pueden eliminar");
                    }
                }else{
                    alert("las filas autogeneradas no se pueden eliminar");
                } 
            }else{
                alert("La fila automatica no se puede eliminar");
            }
        }
          
    }
    
    eliminarDetalleAsiento(datos_fila ,id){
        this.setState({ data_gridCuentas: this.immutableDelete(this.state.data_gridCuentas, id)}
        ,() =>{
            //Asignacion de los label de totales de debe y haber con valores finales
            let final = this.totalizarCuentas(this.state.data_gridCuentas);
            this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)});

            //Renumeración del secuencia de cada fila (corrección por eliminación)
            this.state.data_gridCuentas.forEach((DATA,i)=>{
                DATA.secuencia = completar_String( i + 1, '0', 3)
            })

            //Limpiar grid de seleccion y doc a procesar opcion compra
            if(this.state.opciones === 'C' && datos_fila.CodProveedor === (this.state.ident_prov?this.state.ident_prov.value:null)){
                this.clearOperacionCompra();
            }
            
            this.apiCuentas.refreshCells();
        })
    }

    clear(){
        this.setState({controlGasto: 0, importacion_sel: null, catGastoImportacion_sel: null ,nombreProveedor: '', refBancaria: '',
        switf: '', data_modal_forma_pg: [], ident_prov: null , gridDocsPendientes: [],
        totalDebe: 0, totalHaber: 0, valAplicado: 0, data_gridCuentas:[], 
        data_abonos_import: [] ,total_nota: '', beneficiarioSend: '',
        cod_proveedor: null, cuentaProveedor: null, catRubroGastoImportacion_sel: null, gridSeleccionComprasProv: []})

        //CLEAR CUENTA BANCARIA DEP
        this.setState({cuentaDeporpas: null, SecuenciaCheque: null, catCuentas_sel: null})

        //VUELVE A INGRESO
        this.setState({operacion: 'G'})

        //GRID IMPORTACION
        this.changeStateHeader(this.apiImpFormaPago, this.columnApiImpFormaPago, 'Aplicado', true)

        //GRID COMPRA
        this.changeStateHeader(this.apiDocsPendientes, this.columnApiDocsPendientes, 'Valor_Pagar', true)
    }

    clearOperacionCompra(){
        this.setState({gridSeleccionComprasProv: [], ident_prov: null, nombreProveedor:''})
    }

    clearDocsProcesados(){
        let mensaje = window.confirm(`¿Esta seguro de eliminar todos los documentos a procesar?`);
        if(mensaje){
            this.setState({gridDocsPendientes: []}
            ,()=>{
                let total = 0;
                //ACTUALIZACION DE VALOR ASIENTO PROVEEDOR
                this.state.data_gridCuentas.forEach((DATA)=>{
                    if(DATA.hasOwnProperty('filaProveedor')===true){
                        if(DATA.hasOwnProperty('DebeHaber')===true){
                            console.log("ENTRO")
                            if(DATA.DebeHaber==='H'){
                                console.log("APLICAR: ", total)
                                DATA.Haber = Math.round(total * 100) / 100;
                            }else{
                                console.log("APLICAR: ", total)
                                DATA.Debe = Math.round(total * 100) / 100;
                            }
                        }
                    }
                })

                //Asignacion de los label de totales de debe y haber con valores finales
                let final = this.totalizarCuentas(this.state.data_gridCuentas);
                this.setState({totalDebe: final.debe.toFixed(2), totalHaber: final.haber.toFixed(2)}
                ,()=>{
                    this.apiCuentas.refreshCells();
                })
            });
        }
    }

    limpiarPantalla(param){
        this.clear()
       
        if(param==='A'){
            this.setState({movimientoId: ''})
        }
    }

    getCuentaBancaria(codigo){
        let respuesta = null;

        this.state.catCuentas.forEach((BAN)=>{
            if(BAN.value === codigo){
                respuesta = BAN.label
            }
        })

        return respuesta;
    }

    guardarNotaDebitoCredito(){
        var errors = "";
        var proceder = true;
        var data = {};

        let fechaProceso = getFechaProcesoPorModulo('07');

        if(this.state.opciones === 'O'){
            let result = this.validCamposCompletosImportacion();
            if(result){
                errors+= result.errors;
                proceder=result.proceder;
            }
        }
        
        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(this.state.total_nota!==''){
            let totalNota = parseFloat(this.state.total_nota).toFixed(2);
            let totalGrid = this.state.tipo==="NDE"? parseFloat(this.state.totalHaber).toFixed(2):parseFloat(this.state.totalDebe).toFixed(2);

            if(this.state.opciones!=='O'){
                if(totalNota !== totalGrid){
                    proceder = false;
                    errors = errors + '- El total del documento '+totalNota+' ,no es igual al monto total de las cuentas  '+totalGrid+'.\n'
                }
            }else if(this.state.opciones==='O'){
                let debe = parseFloat(this.state.totalHaber).toFixed(2);
                let haber = parseFloat(this.state.totalDebe).toFixed(2);

                if(debe !== haber){
                    proceder = false;
                    errors = errors + '- El debe y el haber no son iguales. \n'
                }
            }
        }else{
            proceder = false;
            errors = errors + '- Ingrese un total de documento.\n'
        }

        if(this.state.data_gridCuentas.length>=2){

            if(parseFloat(this.state.totalDebe).toFixed(2) !== parseFloat(this.state.totalHaber).toFixed(2)){
                proceder = false;
                errors = errors+"- El debe y el haber deben ser iguales.\n"
            }else{
    
                data.Localidad = '01';
                data.Status = 'P';
                data.Referencia = this.state.refBancaria.toString().trim();
                data.FechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);   //STATE FEKCHA PROCESO              
                data.Tipo = this.state.tipo;
                data.Valor = (this.state.totalDebe); //desformatearNumeroDecimal
                //data.Beneficiario = this.state.beneficiario.toString().trim().toUpperCase();
                data.Concepto = this.state.data_gridCuentas[1].concepto.toString().trim().toUpperCase();             
                data.Cuenta = this.state.catCuentas_sel;
                //Campos moneda
                data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
                data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
                data.Usuario = getItemDatosSesion('usuario');
                data.PlanContable = this.state.planVigente;
                //Cta. deporpas
                data.CuentaDeporpas =  this.state.cuentaDeporpas;
                //data.FechaDocumento = formatearFechaMoment_a_String(this.state.fechaDoc)
                data.FechaDocumento = formatearFechaMoment_a_String(this.state.fechaProceso)
    
                //Evaluar los casos a guardar
                if(this.state.opciones==='O'){//OTROS
                    if(this.state.refBancaria !==""){
    
                        data.Operacion = this.state.opciones.toString().trim();
                        data.DetalleMovBanco = this.state.data_gridCuentas;
                        data.TotalBanco = parseFloat(this.state.total_nota);
                        data.beneficiarioSend = this.state.beneficiarioSend!==''?this.state.beneficiarioSend:null;
                        

                        //Adicion de data ==> CodigoGastoImpor ; Importacion
                        if(this.state.importacion_sel){
                            data.Importacion = this.state.importacion_sel.value;
                            data.ImportacionGasto = this.state.catRubroGastoImportacion_sel.value;

                            let valorGasto = 0;

                            this.state.data_gridCuentas.forEach((DATA)=>{
                                if(DATA.cuenta === this.state.ctaParametroImp.toString().trim()){
                                    if(DATA.DebeHaber === 'D'){
                                        valorGasto = valorGasto + DATA.Debe;
                                    }else{
                                        valorGasto = valorGasto + DATA.Haber;
                                    }                                    
                                }                                
                            })

                            data.ValorGasto = parseFloat(valorGasto,10);
                        }
                    }else{
                        proceder = false;
                        errors = errors + '- Ingrese un número de referencia bancaria\n'
                    }  
                }else if(this.state.opciones==='C'){//COMPRA
                    if(this.state.refBancaria!==''){
                        data.Operacion = this.state.opciones.toString().trim();
                        let countProveedor = 0;
                        this.state.data_gridCuentas.forEach((DET)=>{
                            if(DET.hasOwnProperty('CodProveedor') === true ){
                                DET.Proveedor = DET.CodProveedor;
                                countProveedor += 1;
                            }
                        })

                        if(countProveedor > 1){
                            data.Concepto = `AA. ${data.Tipo} N. ${data.Referencia} BAN: ${this.getCuentaBancaria(data.Cuenta)}`
                        }
                        
                        data.Proveedor = null;
                        data.DetalleMovBanco = this.state.data_gridCuentas;
                        data.DetalleCompras =  this.state.gridDocsPendientes;                        
                        data.cuentaProveedor = this.state.cuentaProveedor;
                    }else{
                        proceder = false;
                        errors = errors + '- Verifique la referencia bancaria y el swift que estén ingresados.\n'
                    }    
                }else if(this.state.opciones==='I'){//IMPORTACION
    
                    if(this.state.importacion_sel !== null && parseFloat(this.state.valAplicado)>0){
                        if(this.state.refBancaria!=='' && this.state.switf!==''){
                            if(this.state.tipo==='NDE'){
                                //CASO POR NOTA DE DEBITO
                                //VALIDA EL VALOR DE APLICACION Q ESTE APLICADO EN ALGUNA CUENTA
                                let vericaAplicacion = this.verificaValorAplicado(this.state.data_gridCuentas, parseFloat(this.state.valAplicado).toFixed(2))
                                if(vericaAplicacion===true){
                                    data.Operacion = this.state.opciones.toString().trim();
                                    data.Importacion = this.state.importacion_sel.value;
                                    data.DetalleMovBanco = this.state.data_gridCuentas;
                                    data.FormaPagoImport = this.state.operacion==='G'?this.filtrarFilasFormaPago(this.state.data_modal_forma_pg):this.state.data_abonos_import;
                                    data.TotalAplicado = parseFloat(this.state.valAplicado)
                                    data.TotalBanco = parseFloat(this.state.total_nota).toFixed(2);
                                    data.Swift = this.state.switf.toString().trim().toUpperCase();
                                }else{
                                    proceder = false;
                                    errors = errors + '- Verifique la cta del proveedor, no coincide el valor con la aplicación de las formas de pago.\n'
                                }  
                            }else if(this.state.tipo==='NCR'){
                                    //NOTA DE CREDITO => SIN VALIDACION DE VALOR APLICADO DE FORMAS DE PAGO A UNA CUENTA
                                    data.Operacion = this.state.opciones.toString().trim();
                                    data.Importacion = this.state.importacion_sel.value;
                                    data.DetalleMovBanco = this.state.data_gridCuentas;
                                    data.FormaPagoImport = this.state.operacion==='G'?this.filtrarFilasFormaPago(this.state.data_modal_forma_pg):this.state.data_abonos_import;
                                    data.TotalAplicado = parseFloat(this.state.valAplicado)
                                    data.Swift = this.state.switf.toString().trim();
                            }              
                        }else{
                            proceder = false;
                            errors = errors + '- Verifique la referencia bancaria y el swift que estén ingresados.\n'
                        }                    
                    }else{
                        proceder = false;
                        errors = errors + '- Verifique la importación y el valor a pagar de la misma.\n'
                    }
                } 
            }
        }else{
            proceder = false;
            errors = errors + '- Ingrese ctas para poder guardar el movimiento\n'
        }
        
        console.log("DATA A ENVIAR: ", data);
        //Proceso de grabacion
        if(proceder === true){
            data.idRegAudit= this.props.idRegAudit;

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/creditosdebitosbancarios/':'/creditosdebitosbancarios/'+this.state.movimientoId,
                data
            }
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=> {
                alert(response.data.msg);
                this.setState({ult_transaccion: response.data.transaction})
                this.setState({num_diario: response.data.diario})
                this.setState({operacion: 'G'});
                this.clear();
                this.props.cambiar_VisualizacionLoading(false);
            })
            .catch((error)=>{       
                this.props.cambiar_VisualizacionLoading(false);   
                alert(error.response?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }     
    }

    //Rutina lee ND-NC por modificacion   mbaquero anade este texto guia
    getCreditoDebitoById(){
        if(this.state.movimientoId === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movimientoId,10) <= 0 ){
            alert("Movimiento no válido");
            this.clear();
        }else{
            global_axios({
                method: 'GET',
                url: '/movimientosbanco/'+this.state.movimientoId.toString()
            })
            .then((response)=>{
                var res = response.data;
                console.log(res)
                if(res.Tipo === 'NDE' || res.Tipo === 'NCR'){
                    
                    let valor = 0;
                    if(res.Tipo === 'NDE'){
                        valor = Math.round((res.Valor*-1)*100)/100;
                    }else{
                        valor = Math.round((res.Valor)*100)/100;
                    }

                    //CARGAR CABECERA
                    this.setState({operacion: 'M', tipo: res.Tipo, opciones: res.Operacion?res.Operacion.trim():'O', catCuentas_sel: res.Cuenta,
                    total_nota: valor, fechaProceso: moment(res.Fecha, 'DD/MM/YYYY')})

                    //Carga Importacion Cod Gasto
                    if(res.Importacion){

                        this.cargarObjetos('/importaciones?cadena_busq='+res.Importacion.trim()).then((resultImp)=>                        {
                            var importacion = {};
                            importacion.value = resultImp[0].Codigo;
                            importacion.label = resultImp[0].Codigo+' ('+resultImp[0].Descripcion+')';
                            
                            this.cargarObjetos('/importaciongasto?importacion='+importacion.value).then((resultImp)=>                            {
                                var catalogoReformado = [];
                                resultImp.forEach((IMP)=>{
                                    var item = {};
                
                                    item.value = IMP.Codigo;
                                    item.label = IMP.Descripcion+' ('+IMP.Codigo+')';
                                    item.Valor = IMP.Valor;
                                    catalogoReformado.push(item);
                                })
                
                                this.setState({importacion_sel: importacion, catGastoImportacion: catalogoReformado, controlGasto:0 }, ()=>{
                                    this.setState({catGastoImportacion_sel: res.Gasto })
                                })
                            })
                            .catch((error)=>{
                                alert(error.response?error.response.data.msg:error.message);
                            })
                                                                              
                        })
                        .catch((error)=>{
                            alert(error.response?error.response.data.msg:error.message);      
                        });
                    }

                    //PROCESO DE CARGAR LA CUENTA DEL BANCO
                    this.validarcuentaBancaria(res.Cuenta);

                    //Cargar Detalle MovBanco
                    var DMovBanco = res.detBanco;
                    var gridCuentas = [];
                    DMovBanco.forEach((DATA)=>{
                        var item = {};
                        console.log('FILA: ', DATA)
                        item.secuencia = DATA.Secuencia;
                        item.cuenta = DATA.Cuenta;
                        item.descripcion = DATA.desCuenta.Nombre!==null?DATA.desCuenta.Nombre.toString().toUpperCase().trim():'';
                        item.concepto = DATA.Concepto;
                        item.DebeHaber = DATA.DebeHaber;
                        if(DATA.DebeHaber==='H'){
                            item.Haber = DATA.Valor;
                        }else{
                            item.Debe = DATA.Valor;
                        }
                        if(DATA.Proveedor){
                            item.Proveedor = DATA.Proveedor.trim();
                        }
                        //mbaquero 20190528
                        if (DATA.CodigoGastoImp !== null) {
                            
                            item.nombre_gasto = DATA.gastoImp.DESCRIPCION.trim();
                            item.CodigoGastoImp = DATA.CodigoGastoImp;
                        }      
                        console.log(DATA)
                        gridCuentas.push(item)
                    })

                    this.setState({data_gridCuentas: gridCuentas, totalDebe: valor,
                    totalHaber: valor, refBancaria: res.Referencia })
         
                    switch (res.Operacion?res.Operacion.trim():'O') {
                        case 'I':

                            if(res.Importacion){
                                this.cargarObjetos('/importaciones?cadena_busq='+res.Importacion.trim()).then((resultImp)=>{
                                    
                                    var importacion = {};
                                    importacion.value = resultImp[0].Codigo;
                                    importacion.label = resultImp[0].Codigo+' ('+resultImp[0].Descripcion+')';
                                    this.setState({importacion_sel: importacion})
                                    
                                    this.cargarObjetos('/abonosporcreditoimportacion?opcion=abono&movbanco='+this.state.movimientoId.toString()).then((resultAbono)=>{
                                        var abono = resultAbono[0];
                                        var dataAbonos = [];
                                        var swiftRes = "";
                                        var proveedor = "";
                                        var acc = 0;

                                        //Carga de abonos
                                        abono.AbonoDet.forEach((ABONO)=>{
                                            var item = {};
                                            item.Secuencia = ABONO.Secuencia;
                                            item.Abono =  ABONO.Abono;
                                            if(swiftRes===""){
                                                swiftRes = ABONO.Swift;
                                            }
                                            item.FechaPago =  ABONO.FechaPago;
                                            item.Valor =  ABONO.Valor.toFixed(2);

                                            acc = acc + ABONO.Valor.toFixed(2);

                                            dataAbonos.push(item);
                                        })

                                        if(abono.Import!==null){
                                            if(abono.Import.impName!==null){
                                                if(abono.Import.impName.RazonSocial!==null){
                                                    proveedor = abono.Import.impName.RazonSocial.toString().trim();
                                                }
                                            }
                                        }
                                        this.setState({data_abonos_import: dataAbonos, switf: swiftRes,
                                            nombreProveedor: proveedor, valAplicado: parseFloat(acc)})
                                    })
                                })
                                .catch((error)=>{
                                    alert(error.response?error.response.data.msg:error.message);      
                                });
                            }
                            break;
                        case 'C':
                            if(res.Proveedor !== null){
                                this.cargarObjetos('/proveedores/'+res.Proveedor).then((resul)=>{
                                    this.setState({ident_prov: {value: res.Proveedor, label: `${resul.razon_social} (${res.Proveedor})` }, nombreProveedor: resul.razon_social})
                                })
                            }

                            //CARGAR GRID FACTURAS A PAGAR (DPDMovBanco)
                            this.cargarObjetos('/pagos/'+this.state.movimientoId).then((result)=>{
                                var docPagado = this.cargarDPDMovBanco(result);
                                this.setState({gridDocsPendientes: docPagado})

                                //GRID COMPRA SET NO EDITABLE
                                this.changeStateHeader(this.apiDocsPendientes, this.columnApiDocsPendientes, 'Valor_Pagar', false)
                            })
                            break;

                        case 'O':
                            this.setState({beneficiarioSend: res.Beneficiario!==null?res.Beneficiario:''})
                            break;
                        default:
                            break;
                    }
                }else{
                    alert("El movimiento no corresponde con una NC/ND");
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    anularDebitoCredito(){
        let msg = window.confirm(`Esta apunto de anular el recibo #: ${this.state.movimientoId}, ¿Continuar?`);

        if(msg){
            var errors = "";
            var proceder = true;

            if(this.state.operacion === 'M' && this.state.permiso === 'M'){
                proceder = true;

            }else if(this.state.operacion === 'M' && this.state.permiso !== 'M'){
                proceder = false;
                errors = errors+"- Solo supervisor puede ejercer cambios sobre los movimientos.\n"
            }

            if(proceder === false){
                alert(errors);
            }

            if(proceder === true){
                global_axios({
                    url: '/creditosdebitosbancarios/'+this.state.movimientoId,
                    method: 'DELETE',
                    headers: {'idregaudit': this.props.idRegAudit}
                })
                .then((response)=>{
                    alert(response.data.msg);
                    this.setState({ult_transaccion: response.data.transaction})
                    this.setState({num_diario: response.data.diario})
                    this.limpiarPantalla('A');
                    this.setState({operacion: 'G'});
                })
                .catch((error)=>{                
                    alert(error.response?error.response.data.msg:error.message);
                    this.limpiarPantalla('A');
                });
            }
        }
    }

    cargarDPDMovBanco(arrayEntrante){
        
        var docsProcesados = [];        

        arrayEntrante.forEach((DATA, i)=>{
            if(DATA.compraDet !== null){
                //CASO PROVEEDORES
                let item = {};
                item.Secuencia = i+1;
                item.Fecha_FAC = DATA.compraDet.Fecha;
                item.Fecha_VEN = DATA.compraDet.FechaVencimiento;
                item.Tipo = DATA.compraDet.Tipo!==null?DATA.compraDet.Tipo:'';
                item.Num_Doc = DATA.compraDet.Establecimiento.toString().trim()+''+DATA.compraDet.PuntoVenta.toString().trim()+'-'+DATA.compraDet.Factura.toString().trim()
                item.Nom_Proveedor = DATA.compraDet.proveedorDet!==null?DATA.compraDet.proveedorDet.RazonSocial:'N/A'
                if(this.state.opciones === 'C'){
                    item.Proveedor = DATA.compraDet.proveedorDet!==null?DATA.compraDet.proveedorDet.RazonSocial:'N/A'
                }
                item.Saldo = DATA.compraDet.Saldo.toFixed(2); 
                item.Valor_Pagar = DATA.Valor!==null?DATA.Valor!==""?DATA.Valor:0:0;
                item.Compra = DATA.Compra;
                docsProcesados.push(item);
            }else{
                //CASO VARIOS
                if(DATA.cuentaDet!==null){
                    let item = {};
                    item.Cuenta = DATA.Cuenta.trim();
                    item.Nombre = DATA.cuentaDet.Nombre.trim();
                    item.Valor = DATA.Valor;
                    if(DATA.flujoDet!==null){
                        item.Flujo = DATA.flujoDet.Descripcion.trim();
                        item.codFlujo = DATA.Flujo.trim();
                    }
                    docsProcesados.push(item);
                }
            }
        })
        
        return docsProcesados;
    }

    disableTotalDoc(){
        if(this.state.operacion==='G'){
            if(this.state.cuentaDeporpas===null){
                return true
            }else{
                return false
            }
        }else{
            //Modificacion
            return true
        }
        
    }

    filtrarFilasFormaPago(array){
        var newArray = []

        array.forEach((DATA)=>{
            if(DATA.Aplicado > 0){
                newArray.push(DATA);
            }
        })

        return newArray;
    }
    
    componentDidMount(){
        Promise.all([
            this.cargarCatalogos_OtrosParametrosSimplex('COM-PARIMPCTA'), 
            cargarCatalogos_Otros('SECBAN-NDNC'),           
            cargarCatalogos_Otros('GEN-PLANVIG'), 
            cargarCatalogos_Otros('IMP-RUBROGASTO'),
            this.cargarCatalogosOtrosCatchResult('BAN-CTASDEP', 'repCuentas'),
            this.cargarOtrosCatchResult('CAJA-CTAS', 'repCtasCaja'), 
            this.props.generar_LogAuditoriaIngresoForm('0703'), ])
        .then(([ resultParamImpCta, ultSec, r_planVigente, r_catRubroGastoImportacion, r_ctasBancarias, r_repCtasCaja]) => { 
            
            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('07');
            
            this.setState({ctaParametroImp: resultParamImpCta[0].Descripcion, ult_transaccion: ultSec[0].value, planVigente: r_planVigente[0].value, 
            catRubroGastoImportacion: r_catRubroGastoImportacion,
            catCuentas: r_ctasBancarias, repCtasCaja: r_repCtasCaja, permiso: this.props.permiso, fechaProceso: moment(fechaProceso,'DD/MM/YYYY')})
        });
        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0703');
    }

    //FUNCTION ADDED 29/01/19
    changeImportacion(value){
        if(Array.isArray(value)){value=null};this.setState({importacion_sel: value!==null?value:null});

        if(value !== null){
            this.cargarObjetos('/importaciongasto?importacion='+value.value).then((resultImp)=>{
                var catalogoReformado = [];
                resultImp.forEach((IMP)=>{
                    var item = {};

                    item.value = IMP.Codigo;
                    item.label = IMP.Descripcion+' ('+IMP.Codigo+')';
                    item.Valor = IMP.Valor;
                    catalogoReformado.push(item);
                })

                this.setState({catGastoImportacion: catalogoReformado, controlGasto:0})
            })
            .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            this.setState({catGastoImportacion: [], catGastoImportacion_sel: null})
        }        
    }

    //FUNCTION PARA VALIDAR IMPORTACION
    validCamposCompletosImportacion(){
        let result = {};
        let found = false;

        //Validacion si existe una importacion seleccionada
        if(this.state.importacion_sel){
            if(this.state.catRubroGastoImportacion_sel!==null){
                found = false;
                this.state.data_gridCuentas.forEach((CTAS)=>{
                    if(CTAS.cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim()){
                        found = true;
                    }
                })

                if(found === false){
                    result.proceder = false;
                    result.errors = '- Ingrese la cuenta del gasto de importación antes de proceder.\n'
                }
            }else{
                result.proceder = false;
                result.errors = '- Seleccione un gasto de importación antes de continuar.\n'
            }
        }else{
            //Verifica Cuenta de provision ingresada sin importacion
            this.state.data_gridCuentas.forEach((CTAS)=>{
                if(CTAS.cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim()){
                    result.proceder = false;
                    result.errors = '- Seleccione una importacion y un gasto antes de continuar.\n'
                }
            })
        }

        if(Object.keys(result).length === 0){
            result = null;
        }

        return result;
    }

    cargarCatalogos_OtrosParametrosSimplex(tipo){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    setCodGastoImportacion(value){
        this.setState({catGastoImportacion_sel: value!==null?value:null})

        if(value){
            this.setState({controlGasto: 1})
        }
    }

    impRecibo(){
        if(this.state.movimientoId){
            visualizarReporteEnPdf('&rpt=14&param1='+this.state.movimientoId)
        }else{
            alert("Carge un movimiento antes de continuar...")
        }
    }

    render(){
        const invisible = {display: 'none'};
        const visible = {display: 'block'};
        
        return(
            <ContenedorForm porc_ancho={85}>
             <HeaderForm>
                <TituloForm>Notas de credito/debito</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario.: {this.state.num_diario}</LabelCabecera> 
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='2' alto='45'>
                        <Row>
                            <ContainerCol className='col-sm-1'>
                                <LabelForm>Movimiento:</LabelForm>                                
                            </ContainerCol> 
                            <ContainerCol className='col-sm-2'>
                                <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId} func_CambiarValor={this.actualizarCampos} 
                                func_BuscarValor={this.getCreditoDebitoById} func_OnFocus={()=>{this.limpiarPantalla('B')}} maxLength='10'/>    
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo:</LabelForm>
                            <div className='flex-container' >
                                <div className='flex-item-ajust'>
                                    <LabelSub><Radio name="tipo" type='radio'  value='NDE' onChange={this.actualizarTipo} checked={this.state.tipo==='NDE'?true:false}/>{' N/D'}</LabelSub>
                                </div>  
                                <div className='flex-item-ajust'>
                                    <LabelSub><Radio name="tipo" type='radio'  value='NCR' onChange={this.actualizarTipo} checked={this.state.tipo==='NCR'?true:false} />{' N/C'}</LabelSub>
                                </div>                                                                   
                            </div>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Operación:</LabelForm>
                            <div className='flex-container' >
                                <div className='flex-item-ajust'>
                                    <LabelSub><Radio name="opciones" type='radio' disabled={false} value='I' onChange={this.actualizarCampos} checked={this.state.opciones==='I'?true:false}/>{' Import.'}</LabelSub>
                                    <LabelSub><Radio name="opciones" type='radio' disabled={this.state.tipo==='NCR'?true:false} value='C' onChange={this.actualizarCampos} checked={this.state.opciones==='C'?true:false}/>{" Compras"}</LabelSub>
                                </div>
                                <div className='flex-item-ajust'>
                                    <LabelSub><Radio name="opciones" type='radio'  value='O' onChange={this.actualizarCampos} checked={this.state.opciones==='O'?true:false}/>{' Otros '}</LabelSub>
                                </div>                                
                            </div>
                        </ContainerCol>  
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Cta. Bancaria:</LabelForm>
                            <ReactSelect options={ this.state.catCuentas } disabled={this.state.data_gridCuentas.length>0 && this.state.operacion==='G'?true:false} value={this.state.catCuentas_sel} func_onChange={(value)=>{this.changeCuentaBancaria(value)}}/>
                        </ContainerCol>                     
                        {/* <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Doc.:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDoc} func_onChange={(fecha)=>{this.setState({fechaDoc: fecha})}}/>
                        </ContainerCol> */}
                        <ContainerCol className='col-sm-2'>{/* style={this.state.opciones==='I'?visible:invisible} */}
                            <LabelForm>Total documento:</LabelForm>
                            <InputText name='total_nota' autoComplete='off' disabled={this.disableTotalDoc()} value={this.state.total_nota} className='form-control input-sm' onChange={this.onChangeMonto} onBlur={this.AsignarValorCuentaBanco} maxLength='10'/>
                        </ContainerCol> 
                        <ContainerCol className='col-sm-2 '>
                            <LabelForm>Fecha Trans.:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}/>
                        </ContainerCol>                        
                    </Row>
                    {/*IMPORTACION*/}
                        <Row style={this.state.opciones==='I' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <div className='col-sm-5'>
                                <ContainerConbinado className='col-sm-2'>
                                    <LabelForm>Import.:</LabelForm>
                                </ContainerConbinado>
                                <ContainerConbinado className='col-sm-6 col-sm-offset-4 col-sm-pull-4'>
                                    <ReactSelectAsync value={this.state.importacion_sel} func_loadOptions={this.getOptions_Importaciones} disabled={this.state.operacion==='M'}
                                    func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}} func_onBlur={this.getFormaPagoImp}/>
                                </ContainerConbinado>                     
                        
                                <ContainerConbinado className='col-sm-2 '>
                                    <LabelForm>Prov.:</LabelForm>
                                </ContainerConbinado>
                                <ContainerConbinado className='col-sm-10'>
                                    <InputText ancho='85' name='nombreProveedor' disabled={true} value={this.state.nombreProveedor} className='form-control input-sm' placeholder='Proveedor' onChange={this.actualizarCampos}/>
                                </ContainerConbinado>

                                <ContainerConbinado className='col-sm-2 '>
                                    <LabelForm>Ref. Bancaria:</LabelForm>
                                </ContainerConbinado>
                                <ContainerConbinado className='col-sm-10'>
                                    <InputText ancho='38' name='refBancaria' value={this.state.refBancaria} className='form-control input-sm' placeholder='referencia' onChange={this.actualizarCampos} maxLength='12'/>
                                </ContainerConbinado>

                                <ContainerConbinado className='col-sm-2 col-sm-pull-2'>
                                    <LabelForm>Switf:</LabelForm>
                                </ContainerConbinado>
                                <ContainerConbinado className='col-sm-8 col-sm-pull-2'>
                                    <InputText ancho='70' mayusculas="true" name='switf' value={this.state.switf} className='form-control input-sm' placeholder='Switf' onChange={this.actualizarCampos} maxLength='20'/>
                                </ContainerConbinado>
                            </div>
                            <div className='col-sm-7' style={this.state.operacion==='G' && this.state.cuentaDeporpas!==null?visible:invisible}>
                                <LabelForm>Formas de pago:</LabelForm>
                                <AgGridRender altura='79px' data={this.state.data_modal_forma_pg} columnas={this.state.columnDefs_modal} gridOptions={this.gridImpFormaPagoOptions} onGridReady={this.onGridImpFormaPagoReady}/>                                                           
                                <div className='pull-right'>
                                    <div className='flex-container' >
                                        <div className='flex-item-ajust' style={this.state.opciones==='O'?invisible:visible}>
                                            <LabelCabecera>Valor aplicado: ${this.state.valAplicado}</LabelCabecera>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-4 col-sm-offset-3 col-sm-pull-3' style={this.state.operacion==='M' && this.state.cuentaDeporpas!==null?visible:invisible}>
                                <LabelForm>Abono aplicado:</LabelForm>
                                <AgGridRender altura='79px' data={this.state.data_abonos_import} columnas={this.state.columnDefs_abonos} gridOptions={this.gridAbonosOptions} onGridReady={this.onGridAbonosImportReady}/>                                                           
                                <div className='pull-right'>
                                    <div className='flex-container' >
                                        <div className='flex-item-ajust' style={this.state.opciones==='O'?invisible:visible}>
                                            <LabelCabecera>Valor aplicado: ${this.state.valAplicado}</LabelCabecera>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    {/*IMPORTACION*/}

                    {/*COMPRAS*/}
                        <Row style={this.state.opciones==='C' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerConbinado className='col-sm-2'>
                                <LabelForm>Ref. Bancaria:</LabelForm>
                                <InputText ancho='70' name='refBancaria' value={this.state.refBancaria} className='form-control input-sm' placeholder='referencia' onChange={this.actualizarCampos} maxLength='12'/>
                            </ContainerConbinado>

                            <ContainerConbinado className='col-sm-4'>
                                <LabelForm>Id. Prov.:</LabelForm>
                                <ReactSelectAsync value={this.state.ident_prov} disabled={this.state.operacion==='M'} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({ident_prov: value, gridSeleccionComprasProv: []})}} func_onBlur={(value)=>{this.getProveedor(value)}} />
                            </ContainerConbinado>

                            <ContainerConbinado className='col-sm-2'>
                                <LabelForm>Razón Social:</LabelForm>
                                <InputText name="nombreProveedor" disabled={true} value={this.state.nombreProveedor}/>
                            </ContainerConbinado>

                            <ContainerConbinado className='col-sm-2'>
                                <Button type='button' className='btn btn-primary btn-sm' onClick={this.clearDocsProcesados}><i className='fa fa-trash-o fa-lg'/> Limpiar docs. proc.</Button>
                            </ContainerConbinado>
                        </Row>
                        <Row margen_arriba='5' style={this.state.opciones==='C' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerCol className='col-sm-5'>
                                <LabelForm>Selección de docs. pendientes</LabelForm>
                                <AgGridRender altura='100px' data={this.state.gridSeleccionComprasProv} columnas={this.state.colDefSeleccionComprasProv}
                                gridOptions={this.gridSeleccionComprasProvOptions} onGridReady={this.onGridSeleccionComprasProvReady}/>
                            </ContainerCol> 
                            
                            <ContainerCol className='col-sm-7'>
                                <LabelForm>Documentos pendientes a procesar</LabelForm>
                                <AgGridRender altura='100px' data={this.state.gridDocsPendientes} columnas={this.state.coldefDocsPendientes}
                                gridOptions={this.docsPendientesOptions} onGridReady={this.onGridDocsPendientesReady}/>
                            </ContainerCol>  
                        </Row>
                    {/*COMPRAS*/}

                    <Row style={this.state.cuentaDeporpas!==null?visible:invisible}>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Cuenta Contable:</LabelForm>
                            <ReactSelectAsync value={this.state.cuentas_sel} func_loadOptions={this.getOptions_CtaContable}
                            /*func_onChange={this.validacionFlujo}*/ func_onChange={(selectedAccount)=>{this.setState({cuentas_sel: selectedAccount!==null?selectedAccount:null}, ()=>{this.handleHabilitaGasto()})}} 
                            func_OnFocus = {()=>{this.setState({catRubroGastoImportacion_sel: null})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Concepto:</LabelForm>
                            <InputText name='concepto' mayusculas='true' value={this.state.concepto} autoComplete='off' className='form-control input-sm' placeholder='Concepto' onChange={this.actualizarCampos} maxLength='80'/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Valor:</LabelForm>
                            <div  className='input-group'>
                                <InputTextUnion  ancho='20' name='valorAdd' autoComplete='off' value={this.state.valorAdd} className='form-control input-sm' onChange={this.actualizarCampos} onBlur={this.validarMontoAdicion} maxLength='10'/>
                                    <span className='input-group-btn'>
                                         <ButtonUnion type='button' className='btn btn-success btn-sm'onClick={this.addCuenta} ><i className="fa fa-plus"></i> Añadir</ButtonUnion>
                                    </span>
                            </div>
                            {/* anade mbaquero  */}
                        </ContainerCol>   
                        <ContainerCol className='col-sm-3' style={this.state.opciones==='I'?visible:invisible}>
                                <LabelForm>Gasto Importac:</LabelForm>
                                {/* Se usa <div> para agrupar 2 objetos y para unir los 2 objetos usamos input-group */}
                                <div>
                                    <ReactSelect options={ this.state.catRubroGastoImportacion } disabled = {this.state.deshabilitaGasto} value={this.state.catRubroGastoImportacion_sel} 
                                        func_onChange={(value)=>{this.setState({catRubroGastoImportacion_sel: value!==null?value:null})}}/>
                                        
                                </div>                                    
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' style={this.state.opciones==='O'?visible:invisible}>
                            <LabelForm>Ref. Bancaria:</LabelForm>
                            <InputText name='refBancaria' value={this.state.refBancaria} className='form-control input-sm' placeholder='refBancaria' onChange={this.actualizarCampos} maxLength='12'/>
                        </ContainerCol>
                    </Row>

                    {/*OTROS - GASTO IMPORTACION*/}
                        <Row style={this.state.opciones==='O' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerCol className='col-sm-4'>
                                <LabelForm>Importación:</LabelForm>
                                <ReactSelectAsync value={this.state.importacion_sel}  func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.changeImportacion(value)}}/>
                            </ContainerCol> 
                            <ContainerCol className='col-sm-4'>
                                <LabelForm>Cod. Gasto:</LabelForm>
                                <div>
                                        <ReactSelect options={ this.state.catRubroGastoImportacion } disabled = {this.state.deshabilitaGasto} value={this.state.catRubroGastoImportacion_sel} 
                                        func_onChange={(value)=>{this.setState({catRubroGastoImportacion_sel: value!==null?value:null})}}/>
                                </div>                                     
                            </ContainerCol>
                            <ContainerCol className='col-sm-1'>
                                <LabelForm>Valor:</LabelForm><br/>
                                <LabelForm>{this.state.catGastoImportacion_sel===null?'0.00':this.state.catGastoImportacion_sel.Valor}</LabelForm>
                            </ContainerCol>
                        </Row>
                    {/*OTROS - GASTO IMPORTACION*/}
                    
                    <Row style={this.state.cuentaDeporpas!==null?visible:invisible}>
                        <ContainerCol className='col-sm-10'>
                            <LabelForm>Cuentas:</LabelForm>
                            <AgGridRender altura='127px' data={this.state.data_gridCuentas} columnas={this.state.columDefGridCuentas} gridOptions={this.gridCuentasOptions} onGridReady={this.onGridCuentasReady}/>                                                           
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba='25'>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <LabelTotal alineacion='left'>Debe: ${this.state.totalDebe}</LabelTotal>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <LabelTotal alineacion='left'>Haber: ${this.state.totalHaber}</LabelTotal>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <LabelTotal alineacion='left' color={this.state.totalDebe-this.state.totalHaber===0?'green':'red'}>Dif: ${Math.round((this.state.totalDebe-this.state.totalHaber)*100)/100}</LabelTotal>
                                </ContainerCol>
                            </Row>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5}>
                        <ContainerCol className='col-sm-6' >
                            <ContainerCol className='col-sm-2' isInvisible={this.state.opciones==='O'?false:true}>
                                <LabelForm>Beneficiario:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' isInvisible={this.state.opciones==='O'?false:true}>
                                <InputText ancho='70' mayusculas="true" name='beneficiarioSend' value={this.state.beneficiarioSend} className='form-control input-sm' placeholder='N/A' onChange={this.actualizarCampos} maxLength='20'/>
                            </ContainerCol>                                
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.cuentaDeporpas===null || this.state.data_gridCuentas.length===0?true:false} onClick={this.guardarNotaDebitoCredito}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-default btn-sm' disabled={this.state.operacion==='M'&& this.state.movimientoId!==''?false:true} onClick={this.impRecibo}><i className="fa fa-print fa-lg" aria-hidden="true"/> Recibo</button> 
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularDebitoCredito}><i className='fa fa-window-close  fa-lg'/> Anular</button>         
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>            
        )   
    }
}


const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
        }
  });
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, 
                            cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormBanco03);